import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-erro-modalng',
  templateUrl: './erro-modalng.component.html',
  styleUrls: ['./erro-modalng.component.css']
})
export class ErroModalngComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
